import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Grid,
  Divider,
  IconButton,
  Typography,
  Autocomplete,
} from "@mui/material";
import { notification } from "antd";
import { FBIcon, TwitterIcon, WAIcon, EmailIcon } from "../../../../Svg/icons";
import { AllTypoFontStyles } from "../../../../Styles/styles";
import { useSelector } from "react-redux";

const ShareInviteUser = ({ selectedTeams, setSelectedTeams }) => {
  const eventInviteType = "user";

  const [emails, setEmails] = useState([]);
  const [loadingFetchContacts, setLoadingFetchContacts] = useState(false);
  const [token, setToken] = useState(null);
  const accessToken = JSON.parse(localStorage.getItem("accessToken"));

  const eventId = useSelector((state) => state.eventId.eventId);
  const userDataString = localStorage.getItem("userData");
  const userData = JSON.parse(userDataString);
  const userId = userData?.id;
  function encryptParam(param) {
    return btoa(param);
  }
  const encryptedEventId = encryptParam(eventId);
  const encryptedEventInviteType = encryptParam(eventInviteType);
  const apiUrl = process.env.REACT_APP_API_URL;
  const encryptedUserId = encryptParam(userId);

  const newLink = `${apiUrl}/eventinvites?eventId=${encryptedEventId}&eventInviteType=${encryptedEventInviteType}&user=${encryptedUserId}`;
  const handleUserSelectChange = (key, value, index) => {
    const updatedUsers = [...selectedTeams];
    if (!updatedUsers[index]) updatedUsers[index] = { email: "", name: "", lastName: "" };

    updatedUsers[index][key] = value;
    setSelectedTeams(updatedUsers);
  };

  const handleShareClick = (platform) => {
    const encodedLink = encodeURIComponent(newLink);
    let shareUrl = "";
    switch (platform) {
      case "whatsapp":
        shareUrl = `https://wa.me/?text=${encodedLink}`;
        break;
      case "facebook":
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedLink}`;
        break;
      case "twitter":
        shareUrl = `https://twitter.com/intent/tweet?url=${encodedLink}`;
        break;
      case "email":
        shareUrl = `mailto:?subject=You're Invited!&body=${encodedLink}`;
        break;
      case "instagram":
        notification.warning({
          message: "Instagram doesn't support direct links. Copy it manually.",
        });
        return;
      default:
        break;
    }
    if (shareUrl) {
      window.open(shareUrl, "_blank");
    }
  };
  const addMoreSelect = () => {
    const updatedTeams = [...selectedTeams, ""];
    setSelectedTeams(updatedTeams);
  };

  const fetchContacts = async () => {
    setLoadingFetchContacts(true);
    try {
      if (!accessToken || emails.length === 0) {
        window.google.accounts.oauth2
          .initTokenClient({
            client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
            scope: "https://www.googleapis.com/auth/contacts.readonly",
            callback: async (response) => {
              if (response.access_token) {
                localStorage.setItem(
                  "accessToken",
                  JSON.stringify(response.access_token)
                );
                setToken(response.access_token);

                const contactResponse = await fetch(
                  `https://people.googleapis.com/v1/people/me/connections?pageSize=1000&personFields=names,emailAddresses`,
                  {
                    headers: {
                      Authorization: `Bearer ${response.access_token}`,
                    },
                  }
                );

                if (!contactResponse.ok) {
                  throw new Error("Failed to fetch contacts");
                }

                const data = await contactResponse.json();
                const contactsWithEmails = data?.connections?.filter(
                  (contact) => contact.emailAddresses
                );
                const emailList = contactsWithEmails?.map(
                  (contact) => contact.emailAddresses[0]?.value
                );

                if (emailList && emailList.length > 0) {
                  setEmails(emailList);
                  notification.success({
                    message: "Contacts fetched successfully!",
                  });
                } else {
                  setEmails([]);
                  notification.info({
                    message: "No contacts found in your network!",
                  });
                }
              } else {
                throw new Error("Error retrieving access token");
              }
            },
          })
          .requestAccessToken();
      }
    } catch (error) {
      console.error("Error fetching contacts:", error);
      notification.error({
        message: "Failed to fetch contacts!",
        description: error.message,
      });
    } finally {
      setLoadingFetchContacts(false);
    }
  };

  return (
    <Grid spacing={2} p={{ md: 10, xs: 2 }}>
      <Grid
        spacing={{ xs: 1, md: 4 }}
        container
        alignItems="start"
        sx={{ mb: "10%" }}
      >
        <Grid item md={7} sm={12} xs={12}>
          <Grid spacing={2} direction="column" sx={{ width: "100%" }}>
            <Typography sx={AllTypoFontStyles.CommonTypo2}>
              Select User
            </Typography>
            {emails && (
              <Button sx={{ fontSize: "13px", p: 0 }} onClick={fetchContacts}>
                Fetch My Contacts
              </Button>
            )}
            {selectedTeams.map((team, index) => (
              <Grid
                key={index}
                container
                spacing={1}
                alignItems="center"
                mb={1}
              >
                <Grid item xs={5}>
                  <Autocomplete
                    freeSolo
                    options={emails || []}
                    getOptionLabel={(option) =>
                      typeof option === "string" ? option : option.email || ""
                    }
                    onChange={(event, newValue) => {
                      if (typeof newValue === "string") {
                        handleUserSelectChange("email", newValue, index);
                      } else if (newValue && typeof newValue === "object") {
                        handleUserSelectChange("email", newValue.email, index);
                      } else {
                        handleUserSelectChange("email", "", index);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Email"
                        fullWidth
                        onChange={(e) =>
                          handleUserSelectChange("email", e.target.value, index)
                        }
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    placeholder="First Name"
                    fullWidth
                    value={selectedTeams[index]?.name || ""}
                    onChange={(e) =>
                      handleUserSelectChange("name", e.target.value, index)
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    placeholder="Last Name"
                    fullWidth
                    value={selectedTeams[index]?.lastName || ""}
                    onChange={(e) =>
                      handleUserSelectChange("lastName", e.target.value, index)
                    }
                  />
                </Grid>
                <Grid item xs={1}>
                  <IconButton
                    onClick={() => {
                      const updated = selectedTeams.filter(
                        (_, i) => i !== index
                      );
                      setSelectedTeams(updated);
                    }}
                  >
                    ❌
                  </IconButton>
                </Grid>
              </Grid>
            ))}

            <Grid item>
              <Button sx={{ color: "#003366" }} onClick={addMoreSelect}>
                + Add More
              </Button>
            </Grid>
          </Grid>
        </Grid>

        <Grid item md={1} sm={12} xs={12}>
          <Grid container>
            <Grid item md={1} sm={12} xs={12}>
              <Divider
                orientation="vertical"
                sx={{
                  height: "200px",
                  color: "black",
                  display: { sm: "none", xs: "none", md: "block" },
                }}
              />
            </Grid>
            <Grid item md={1} sm={12} xs={12}>
              <Divider
                orientation="horizontal"
                sx={{
                  width: "100%",
                  color: "black",
                  display: { sm: "block", md: "none" },
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item md={4} sm={12} xs={12} mt={{ xs: 1, md: 0 }}>
          <Typography sx={AllTypoFontStyles.CommonTypo2}>Share</Typography>
          <Box textAlign="center">
            <Grid
              container
              spacing={2}
              sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "flex-start",
              }}
            >
              <Grid item xs={6} sm={4} md={6} lg={3}>
                <Box display="flex" flexDirection="column" alignItems="center">
                  <IconButton
                    color="primary"
                    onClick={() => handleShareClick("whatsapp")}
                  >
                    <WAIcon />
                  </IconButton>
                  <Typography sx={AllTypoFontStyles.CommonTypo3}>
                    Whatsapp
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={6} sm={4} md={6} lg={3}>
                <Box display="flex" flexDirection="column" alignItems="center">
                  <IconButton
                    color="primary"
                    onClick={() => handleShareClick("facebook")}
                  >
                    <FBIcon />
                  </IconButton>
                  <Typography sx={AllTypoFontStyles.CommonTypo3}>
                    Facebook
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={6} sm={4} md={6} lg={3}>
                <Box display="flex" flexDirection="column" alignItems="center">
                  <IconButton
                    color="primary"
                    onClick={() => handleShareClick("twitter")}
                  >
                    <TwitterIcon />
                  </IconButton>
                  <Typography sx={AllTypoFontStyles.CommonTypo3}>
                    Twitter
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={6} sm={4} md={6} lg={3}>
                <Box display="flex" flexDirection="column" alignItems="center">
                  <IconButton
                    color="primary"
                    onClick={() => handleShareClick("email")}
                  >
                    <EmailIcon />
                  </IconButton>
                  <Typography sx={AllTypoFontStyles.CommonTypo3}>
                    Email
                  </Typography>
                </Box>
              </Grid>
            </Grid>

            <Box mt={3} sx={{ textAlign: "right" }}>
              <TextField
                value={newLink}
                fullWidth
                InputProps={{
                  readOnly: true,
                }}
              />

              <Button
                sx={{
                  marginTop: 1,
                  borderRadius: 1,
                  backgroundColor: "#2EA7E0",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "#2EA7E0",
                  },
                }}
                onClick={() => {
                  if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard
                      .writeText(newLink)
                      .then(() => {
                        notification.success({
                          message: "Link copied successfully!",
                        });
                      })
                      .catch((err) => {
                        console.error("Failed to copy:", err);
                      });
                  } else {
                    const textArea = document.createElement("textarea");
                    textArea.value = newLink;
                    document.body.appendChild(textArea);
                    textArea.select();
                    try {
                      document.execCommand("copy");
                      notification.success({
                        message: "Link copied successfully!",
                      });
                    } catch (err) {
                      console.error("Fallback: Unable to copy", err);
                    }
                    document.body.removeChild(textArea);
                  }
                }}
              >
                Copy
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ShareInviteUser;
